import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card } from "antd";

import Box from "../components/Box";
import Text from "../components/Text";
import DetailLabel from "../components/DetailLabel";

import axios from "../utils/axios";
import { blockUrl, txUrl } from "../utils/urls";

const TransactionDetail = () => {
  const { txHash } = useParams();

  const [lastBlock, setLastBlock] = useState({});
  const [block, setBlock] = useState(null);
  const [transaction, setTransaction] = useState({});

  const fetchLastBlock = async () => {
    const url = `${blockUrl}/last`;
    axios.get(url).then((response) => {
      if (response.data) {
        setLastBlock(response.data);
      }
    });
  };

  const fetchBlockFromBlockHash = async (blockHash) => {
    const url = `${blockUrl}/hash/${blockHash}`;
    axios.get(url).then((response) => {
      if (response.data) {
        setBlock(response.data);
      }
    });
  };

  const fetchTransaction = async (txHash) => {
    const url = `${txUrl}/${txHash}`;
    axios.get(url).then((response) => {
      if (response.data) {
        setTransaction(response.data);
      }
    });
  };

  useEffect(() => {
    fetchLastBlock();
  }, []);

  useEffect(() => {
    if (transaction.block_id) {
      fetchBlockFromBlockHash(transaction.block_id);
    }
  }, [transaction]);

  useEffect(() => {
    fetchTransaction(txHash);
  }, [txHash]);

  const renderDetail = () => {
    return (
      <Box>
        <Box mb={16}>
          <Text fontSize={24} fontWeight={600}>
            Transaction Info
          </Text>
        </Box>
        <DetailLabel label="Chain ID" value={lastBlock?.header?.chain_id} />
        <DetailLabel label="Tx Hash" value={txHash} />
        <DetailLabel label="Block Height" value={block?.header?.height} />
      </Box>
    );
  };

  const renderTransactionRawData = () => {
    return (
      <Card>
        <Text fontSize={24} fontWeight={600}>
          Data
        </Text>
        <Box>
          {transaction && <pre>{JSON.stringify(transaction, null, 2)}</pre>}
        </Box>
      </Card>
    );
  };

  return (
    <Card>
      {renderDetail()}
      <Box mt={24}>{renderTransactionRawData()}</Box>
    </Card>
  );
};

export default TransactionDetail;
